"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns true iff a transform value is "essentially" a specified basis int.
 */
exports.transformValueIsEssentiallyInt = function (transformValue, basis) { return Math.abs(transformValue - basis) < 1e-6; };
//# sourceMappingURL=transformValueIsEssentiallyInt.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/helpers/transformValueIsEssentiallyInt.js
// module id = 115
// module chunks = 35783957827783 127651196306611 162898551421021